import { render, staticRenderFns } from "./MeetingInfo.vue?vue&type=template&id=195a84d1&scoped=true&"
import script from "./MeetingInfo.vue?vue&type=script&lang=js&"
export * from "./MeetingInfo.vue?vue&type=script&lang=js&"
import style0 from "./MeetingInfo.vue?vue&type=style&index=0&id=195a84d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a84d1",
  null
  
)

export default component.exports